/**
 * External dependencies
 */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Box, Stack, Text } from '@towersystems/towersystems-design-system';
import { map } from 'lodash';

/**
 * Internal dependencies
 */
import Card from 'components/card';
import { requestImages } from 'state/images/actions';
import usePagination from 'modules/dashboard/pagination/use-pagination';
import ImageListTable from './image-list-table';

/**
 * Style dependencies
 */
import './styles.scss';

const ImagesList = ({ connectionId, connectionType, ...props }) => {

    const { currentItems, setCriteria, requestItems, isRequesting, footer } = usePagination(
        props.requestImages,
        {
            criteria: { connection: connectionId },
        },
    );

    console.log(currentItems);

    return (
        <React.Fragment>
            <Stack className='resources__list-wrapper' space='large'>
                <Card>
                    <ImageListTable requestItems={requestItems} requesting={isRequesting} items={currentItems} /> 
                </Card>
                {footer}
            </Stack>
        </React.Fragment>
    );
};

export default connect((state) => ({}), {
    requestImages,
})(ImagesList);
